export default __webpack_public_path__ + "static/hero-7891ae8d6c9e9fcc589c113c5f575e34.webp";